import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../../services/apis";

export function* handleFetchSamplerDetails({ payload }) {
  try {
    const res = yield call(API.fetchSamplerDetails, payload);
    const { data } = res;
    yield put(actions.fetchSamplerDetailsSuccess(data.data));
  } catch (err) {
    yield put(actions.fetchSamplerDetailsFailure(err?.response?.data));
  }
}

export function* handleFetchStates({ payload }) {
  try {
    const res = yield call(API.fetchAllStates, payload);
    const { data } = res;
    yield put(actions.fetchStatesSuccess(data));
  } catch (err) {
    yield put(actions.fetchStatesFailure(err?.response?.data));
  }
}

export function* handleFetchDistricts({ payload }) {
  try {
    const res = yield call(API.fetchDistrictsForState, payload);
    const { data } = res;
    yield put(actions.fetchDistrictsSuccess(data));
  } catch (err) {
    yield put(actions.fetchDistrictsFailure(err?.response?.data));
  }
}

export function* handleEditSampler(payload) {
  try {
    const res = yield call(API.editSampler, payload);
    const { data } = res;
    yield put(actions.editSamplerSuccess(data));
    payload.payload.onSuccess();
  } catch (err) {
    yield put(actions.editSamplerFailure(err?.response?.data));
    payload.payload.onFailure(err?.response?.data);
  }
}

export function* handleFetchAgencies({ payload }) {
  try {
    const res = yield call(API.fetchAllAgencies, payload);
    const { data } = res;
    yield put(actions.fetchAgenciesSuccess(data));
  } catch (err) {
    yield put(actions.fetchAgenciesFailure(err?.response?.data));
  }
}

export function* handleFetchDistrictsOfMultipleStates({ payload }) {
  try {
    const res = yield call(API.fetchDistrictsOfMultipleStates, payload);
    const { data } = res;
    yield put(actions.fetchDistrictsOfMultipleStatesSuccess(data));
    payload.onSuccess();
  } catch (err) {
    yield put(actions.fetchDistrictsOfMultipleStatesFailure(err?.response?.data));
    payload.onFailure();
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export function* samplerEditSaga() {
  yield takeLatest(actions.fetchSamplerDetails.type, handleFetchSamplerDetails);
  yield takeLatest(actions.fetchStates.type, handleFetchStates);
  yield takeLatest(actions.fetchDistricts.type, handleFetchDistricts);
  yield takeLatest(actions.editSampler.type, handleEditSampler);
  yield takeLatest(actions.fetchAgencies.type, handleFetchAgencies);
  yield takeLatest(actions.fetchDistrictsOfMultipleStates.type, handleFetchDistrictsOfMultipleStates);
}
